import { useFonts } from '@/hooks/useFont';
import './quill-snow.css';
import { getHtmlFromString } from '@/util/stringToHtml';

export const TextOnlyPreview = ({
  textContent,
  className,
}: TextOnlyPreviewProps) => {
  const { isLoaded } = useFonts({ textContent });
  if (!isLoaded) return <></>;
  return (
    <div className={`quill txt-prev ${className}`}>
      <div className="ql-container">
        <div
          dangerouslySetInnerHTML={getHtmlFromString(textContent || '')}
          className="ql-editor"
        />
      </div>
    </div>
  );
};
type TextOnlyPreviewProps = {
  textContent: string;
  className?: string;
};
export default TextOnlyPreview;
